import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { environment } from './../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FreightValumeCalService {
  constructor(private http:HttpClient) { }
  API_KEY = environment.API_KEY;

  URL_1 = "https://www.shipco.com/s3w/ocean-freight-volume-calculator-allunits-scan";
  URL_2 ="https://www.shipco.com/s3w/ocean-freight-volume-calculator-formula-scan";
  
  getOFVCLength(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_1,obj);
  }
  getOFVCWeight(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_1,obj);
  }
  getOFVCValume(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_1,obj);
  }
  getOFVCTemp(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_1,obj);
  }


  getLengthRes(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj,{ responseType: 'text' });
  }

  getWeightRes(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj,{ responseType: 'text' });
  }

  getValumeRes(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj,{ responseType: 'text' });
  }

  getTempRes(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj,{ responseType: 'text' });
  }
}
